import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import SeanceList, { DispatchProps, OwnProps, StateProps } from './SeanceListScreen';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getSeances, getSeancesCsv } from 'src/store/actions/seance-actions';
import { selectNameProviders } from '../../../../../../store/selectors/providers-selectors';
import { selectNameStudents } from '../../../../../../store/selectors/students-selectors';
import { getProvidersSmall } from '../../../../../../store/actions/provider-actions';
import { getStudentsSmall } from '../../../../../../store/actions/student-actions';
import { getVendorsSmall } from '../../../../../../store/actions/vendor-actions';
import { getServiceLocations } from '../../../../../../store/actions/service-location-actions';
import { getServiceTypes } from '../../../../../../store/actions/service-type-actions';
import { getDistrictsSmall } from '../../../../../../store/actions/district-actions';
import { selectNameDistricts } from '../../../../../../store/selectors/districts-selectors';
import { selectNameVendors } from '../../../../../../store/selectors/vendors-selectors';
import { selectNameServiceTypes } from '../../../../../../store/selectors/service-types-selectors';
import { selectNameServiceLocations } from '../../../../../../store/selectors/service-location-selectors';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.seances.data,
        inProgress: state.seances.inProgress,
        providers: selectNameProviders(state),
        students: selectNameStudents(state),
        districts: selectNameDistricts(state),
        vendors: selectNameVendors(state),
        serviceTypes: selectNameServiceTypes(state),
        serviceLocations: selectNameServiceLocations(state),
        inProgressCSV: state.seances.inProgressCSV,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getSeances(params)),
        getDataCsv: (params: QueryParams) => dispatch(getSeancesCsv(params)),
        getProviders: (params: QueryParams) => dispatch(getProvidersSmall(params)),
        getStudents: (params: QueryParams) => dispatch(getStudentsSmall(params)),
        getDistricts: (params: QueryParams) => dispatch(getDistrictsSmall(params)),
        getVendors: (params: QueryParams) => dispatch(getVendorsSmall(params)),
        getServiceTypes: (params: QueryParams) => dispatch(getServiceTypes(params)),
        getServiceLocations: (params: QueryParams) => dispatch(getServiceLocations(params)),
    };
}

const SeanceListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(SeanceList);

export default SeanceListScreen;
